<template>
    <div class="tiles-container">
        <tile v-for="(recipe, index) in recipes" :key="index" :index="index" :recipe="recipe" />
        <mix-footer />
    </div>
</template>

<script>
import Tile from "@/components/mixology/Tile";
import MixFooter from '@/components/mixology/MixFooter';

export default {
    name: "tiles-container",
    props: {
        recipes: {
            type: Array
        }
    },
    components: {
        Tile,
        MixFooter
    }
};
</script>

<style lang="scss">
    .tiles-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        overflow: hidden;

        @media(min-width: 768px){
            flex-direction: row;
            flex-wrap: wrap;
            align-items: flex-start;
            align-content: flex-start;
            width: 50%;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/mixology/TilesContainer.vue